import type { Tweet } from '@/types/api';
import { DEFAULT_AVATAR } from '@/lib/utils';
import { TweetBadges } from './TweetBadges';

interface TweetHeaderProps {
  tweet: Tweet;
}

export function TweetHeader({ tweet }: TweetHeaderProps) {
  return (
    <div className="tweet-header flex items-center gap-3 mb-3">
      <img
        src={tweet.user_avatar_url || DEFAULT_AVATAR}
        alt=""
        className="tweet-avatar w-12 h-12 rounded-full object-cover"
        onError={(e) => {
          e.currentTarget.src = DEFAULT_AVATAR;
        }}
      />
      <div className="tweet-author flex-1 min-w-0">
        <div className="tweet-name font-bold text-sm truncate">{tweet.user_name}</div>
        <div className="tweet-screen-name text-text-secondary text-sm">@{tweet.screen_name}</div>
      </div>
      <TweetBadges types={tweet.types} />
    </div>
  );
}
